





















import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import SearchStore from '@/store/SearchStore.brain';
import DetailStore from '@/store/DetailStore';

import * as d3Import from '../../../../static/lib/d3.v4.min.js';
let d3: any = d3Import;
import forceGraphBrain from '../../../dv-pure-render/force-graph/brain/brain.js';
import '../../../dv-pure-render/force-graph/src/force-graph.css';
import {getEntityType} from '../../../utils/util';


@Component({components: {}})
export default class ForceGraphWrap extends Vue {
    searchData = SearchStore.state;
    detailData = DetailStore.state;
    forceGraphClass = $qsObj.force === 'true' ? 'fly-in' : 'fly-out';
    $mountNode: any;
    forceGraphKG: any;
    cancelToken: any;
    aef: any;

    cancelTokenDraw: any;
    aefDraw: any;

    @Prop({})
    loading: any;

    @Prop({})
    poiGraph: any;

    @Prop({})
    userGraph: any;

    @Prop({})
    entityType: any;

    @Prop({})
    graphInfo: any;

    get poiData3d () {return this.detailData.poiData3d}
    get poiData () {return this.detailData.poiData}
    @Watch('loading')
    async loadingChange (newVal:any, oldVal: any) {
        console.log('forceGraph loading', newVal, oldVal);
        if(newVal){
            this.forceGraphClass = 'fly-out';
        }else{
            this.forceGraphClass = 'fly-in';
        }
        // 你居然操作DOM 下次记得不可以这样子啊

        // await this.$sleep(3000);
        // this.forceGraphClass = 'fly-in';
        // this.forceGraphKG.light(0);
        // await this.$sleep(1000);
    }

    @Watch('graphInfo')
    onGraphInfoChange (newVal, oldVal) {
        if (newVal.subjectId !== oldVal.subjectId) {
            // (window as any)._app.$emit('slider-reset');
            this.$bus.$emit('slider-reset');
            // let slide:any = this.$refs.forceSlide;
            // slide.reset();
        }
    }

    @Watch('poiGraph', {immediate: true})
    async onPoiGraph (poiGraph: any, oldVal: any) {
        await this.$sleep(0); // immediate会在beforeCreate之后created之前触发
        if (poiGraph.nodes && poiGraph.links) {
            this.draw({graphData: poiGraph});
        }
    }

    @Watch('userGraph',  {immediate: true})
    async onUserGraph (userGraph: any, oldVal: any) {
        await this.$sleep(0); // immediate会在beforeCreate之后created之前触发
        if (userGraph.nodes && userGraph.links) {
            this.draw({graphData: userGraph});
        }
    }

    nodeClick () {}

    scaleSmall () {
        // if (this.poiData3d.rootId === this.poiData.SubjectId) {
        //     this.$bus.$emit('2d-to-3d');
        // }
    }

    async nodeDblClick (node, fly = true) {
        let subjectId = node.id_origin || node.id;
        let entityType = getEntityType(node.type);
        console.log('dblclick', entityType, node.type, node.id_origin);
        if (this.entityType === 'user' && node.depth === '0') {
            console.log('双击Tag 不进行转跳');
            return void 0;
        }
        if (fly && (entityType === 'user' || entityType === 'poi')) {
            this.$bus.$emit('force-RightLeft-fly');
        }
        let addHistory = () => {
            SearchStore.addHistory({
                subjectId: node.id_origin,
                type: node.type,
                name: node.name
            });
        };

        if (entityType === 'user') {
            addHistory();
            await Promise.all([
                DetailStore.getUserDataBySubjectId(subjectId),
                DetailStore.getUserGraph({subjectId})
            ]);
        } else if (entityType === 'poi') {
            addHistory();
            // SearchStore.addHistory({
            //     name: this.detailData.poiData['名称'],
            //     subjectId: node.id_origin,
            //     type: node.type,
            // });
            await Promise.all([
                DetailStore.getPoiDataBySubjectId(subjectId),
                DetailStore.getPoiGraph({subjectId})
            ]);
        } else {
            console.log('双击Tag 不进行转跳');
        }
        if (fly && (entityType === 'user' || entityType === 'poi')) {
            await this.$sleep(3000);
            this.$bus.$emit('force-RightLeft-fly', 'fly-in');
        }
    }

    *drawGen ({graphData}) {
        this.forceGraphKG = forceGraphBrain({
            dom: this.$refs.mountNodeForceGraph2d,
            d3: d3,
            data: graphData, entityType: this.entityType,
            onClick: this.nodeClick,
            onDblClick: this.nodeDblClick,
            scaleSmall: this.scaleSmall,
        });
        // 中心图谱开发的模式就加快展示时间
        if ($qsObj.force !== 'true') {
            yield this.$sleep(3000);
        }
        this.forceGraphClass = 'fly-in';
        yield this.forceGraphKG.light();
        yield this.$sleep(1000);
    }

    draw ({graphData}) {
        // 先停止和取消之前的
        if (this.cancelTokenDraw && this.cancelTokenDraw.abort) {
            this.cancelTokenDraw.abort();
        }
        if (this.forceGraphKG && this.forceGraphKG.destroy) {
            this.forceGraphKG.destroy();
            this.forceGraphKG = null;
        }
        this.cancelTokenDraw = null;
        this.aefDraw = null;

        this.cancelTokenDraw = new this.$ae.CancelToken();
        this.aefDraw = this.$ae(this.drawGen, this.cancelTokenDraw);
        this.aefDraw({graphData});
    }

    *actionScriptForceGraph () {
        let targetId = $foodConfig.poi2dAutoJump;
        let rootId = $foodConfig.poi3dMid;
        this.forceGraphKG.stopOD();
        this.forceGraphKG.dark(0);
        yield this.$sleep(1000);

        if ($qsObj.quickall !== 'true') {
            this.forceGraphKG.lightStep(3000);
            yield this.$sleep(3000 * 4);

            this.forceGraphKG.dark();
            yield this.$sleep(2000);
        }

        let poiHighLight = $foodConfig.poi2dAutoHighLightListObj;
        for (let i = 0; i < poiHighLight.length; i ++) {
            let nodeObj = poiHighLight[i];
            let node = this.forceGraphKG.data.nodes.find(_node => {
                let flag = true;
                for (let key in nodeObj) {
                    if (nodeObj[key] !== _node[key]) {
                        flag = false;
                        break;
                    }
                }
                return flag;
            });

            if (!node) {debugger}
            this.forceGraphKG.setHighlight(node);
            yield this.$sleep(3000);
        }

        // 中途要转跳到case项目
        if ($qsObj.forcase === 'true') {
            this.forceGraphKG.stopOD();
            this.forceGraphKG.dark(0);
            this.forceGraphKG.zoomTo(.3, 3000);
            this.$bus.$emit('force-RightLeft-out', 'fly-in');
            yield this.$sleep(3000);

            this.forceGraphClass = 'fly-out';
            location.href = $qsObj.forcaseurl ? decodeURIComponent($qsObj.forcaseurl) : 'https://brain.meituan.com/case/';
        }
        let threeNode = this.forceGraphKG.data.nodes.find(_ => _.id_origin === targetId && _.rootId === rootId);
        if (!threeNode) {
            debugger
        } else {
            yield this.forceGraphKG.setHighlightStep(threeNode);
            // yield this.$sleep(3000);

            let tarEle = $('#node-0_'+targetId);
            let tarEleText = tarEle.find('.kg-force-text');
            let curTransform = tarEle.css('transform');
            let curTransition = tarEle.css('transition');
            tarEle.css('transform', curTransform + ' scale(2)');
            tarEle.css('transition', curTransition + ', transform 1s ease');
            tarEleText.css('transform', `translate(5px, 5px)`);
            yield this.$sleep(3000);

            this.nodeDblClick(threeNode, false);
            yield this.$sleep(3000); // 给请求的时间

            yield this.$bus.$emit('force-RightLeft-out');
            yield this.$sleep(8000); // 给看第二个POI展开的时间

            this.forceGraphKG.stopOD();
            this.forceGraphKG.dark(0);
            yield this.$sleep(1000);
            this.forceGraphKG.lightStep(3000);
            yield this.$sleep(3000 * 4);
        }


        this.forceGraphKG.zoomTo(.3, 3000);
        this.$bus.$emit('force-RightLeft-out', 'fly-in');
        yield this.$sleep(3000);

        this.forceGraphClass = 'fly-out';

    }

    addKeyMapListener () {
        this.$autoOnNative(window, 'keydown', async (e) => {
            let list = [];
            switch (e.keyCode) {
                case 37:
                    list = this.forceGraphKG.findSideNode('left');
                    break;
                case 38:
                    list = this.forceGraphKG.findSideNode('top');
                    break;
                case 39:
                    list = this.forceGraphKG.findSideNode('right');
                    break;
                case 40:
                    list = this.forceGraphKG.findSideNode('bottom');
                    break;
                default:
                    return void 0;
            }
            let selectNode = list[0];
            let data = await DetailStore.getPoiGraphOnly({subjectId: selectNode.id_origin, isAppend: true});
            this.forceGraphKG.updateData(data);
        });
    }

    mounted () {
        this.$mountNode = this.$refs.mountNodeForceGraph2d as HTMLDivElement;

        this.cancelToken = new this.$ae.CancelToken();
        this.aef = this.$ae(this.actionScriptForceGraph, this.cancelToken);

        this.$autoOn('force-graph-reset', () => {this.forceGraphKG.reset();});
        this.$autoOn('force-zoom-in', () => {this.forceGraphKG.zoomIn();});
        this.$autoOn('force-zoom-out', () => {this.forceGraphKG.zoomOut();});

        // 图谱自动动画
        this.$autoOn('force-graph-animation', this.aef);

        this.$autoOn('window-resize', () => {
            if (this.forceGraphKG && this.forceGraphKG.destroy) {
                if (this.entityType === 'user') {
                    this.draw({graphData: this.userGraph});
                } else {
                    this.draw({graphData: this.poiGraph});
                }
            }
        });

        this.$autoOn('action-script-stop', () => {
            this.cancelToken && this.cancelToken.abort();
            this.cancelTokenDraw && this.cancelTokenDraw.abort();
            // this.forceGraphKG.stop(); // 不需要stop方法了
        });
        this.$autoOn('action-script-start', () => {
            this.cancelToken = null;
            this.cancelTokenDraw = null;
        });
        // this.addKeyMapListener();
    }
}
